export function setToken(token: string) {
  return window.localStorage.setItem('converse_authkey', token);
}

export function getCookie(cname: string): string {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function getQueryParam(param: string): string | null {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get(param);
}

export function getRedirectAfterSignInPath(): string {
  const next = getQueryParam('next');
  return next || '/';
}

export const initiateSmartsheetSignIn = () => {
  window.location.href = '/v2/oauth/login';
};
